import React from "react";
import {
  Grid,
  TextField,
  Typography,
  Box,
  useTheme,
  MenuItem,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const FeaturedForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = theme.palette.status.accent;

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderLeft: `3px solid ${red}`,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        Generate Featured Images
      </Typography>

      <Grid container spacing={2}>
        {/* Camera Direction */}
        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Camera Direction"
            fullWidth
            value={config.cameraDirection || ""}
            onChange={(e) => onChange("cameraDirection", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          >
            <MenuItem value="cw">Clockwise</MenuItem>
            <MenuItem value="ccw">Counter-Clockwise</MenuItem>
          </TextField>
        </Grid>

        {/* Leg Height */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Leg Height (in inches)"
            type="number"
            fullWidth
            value={config.unitHeight || ""}
            onChange={(e) => onChange("unitHeight", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FeaturedForm;
